import React from 'react';
import './DemoBanner.css';

const DemoBanner: React.FC = () => {
  return null;
};

export default DemoBanner;
